import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/sathishzus.jpeg`} alt="" />
      </Link>
      <header>
        <h2>Sathishzus</h2>
        <p><a href="mailto:sathishzus@sathishzus.me">sathishzus@sathishzus.me</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Sathishzus. I am a <a href="https://mvit.edu.in/">MVIT</a> Student.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Sathishzus <Link to="/">Sathishzus.me</Link>.</p>
    </section>
  </section>
);

export default SideBar;
